/* eslint-disable no-unused-vars */
import Vue from 'vue'

const router = {
  namespaced: true,
  state: {
    path: false
  },
  actions: {
    setPath ({ state }, path) {
      Vue.set(state, 'path', path)
      /* var event = new CustomEvent('popstate');
      window.dispatchEvent(event) */
      //console.log('setted path to', path)
      return true
    },
    async getPath ({ commit, state, dispatch }, { fullPath, name, params, meta }) {
      let routeName = name.split(':'),
          routePath = fullPath.split('/'),
          path = {
            root: routeName[0],
            root_path: routePath[1],
            page_mode: (typeof meta.type !== 'undefined' && meta.type === 'page' ? 'page' : 'root'),
            page: false,
            page_path: (typeof params.page !== 'undefined' && params.page ? params.page : false),
            id: (typeof params.id !== 'undefined' && parseInt(params.id) > 0 ? parseInt(params.id) : false),
            action: false,
            type: false
          }
      if (typeof this.state.language.meta.pages[path.root] !== 'undefined' && Object.keys(this.state.language.meta.pages[path.root]).length > 0) {
        if (typeof params.page !== 'undefined' && params.page) {
          let pages = Object.entries(this.state.language.meta.pages[path.root].pages).map(e => Object.assign({ key: e[0] }, e[1])),
              page = pages.find(element => element.path === params.page),
              pageKey = (page ? page.key : false)
          if (pageKey) {
            path.page = pageKey
            path.action = (routeName.length > 2 ? routeName[2] : false)
            path.type = (routeName[1] === 'root' ? 'root' : 'page')
            return path
          }
        } else {
          path.action = (routeName.length > 1 ? routeName[1] : false)
          path.type = 'root'
          return path
        }
      }
      return false
    },
    async getPermission ({ commit, state, dispatch }, { root, page, action, type }) {
      var permission = false
      if (page) {
        if (type === 'root') {
          permission = (action ? this.state.login.logged_user.permissions[page]['actions'][action] : this.state.login.logged_user.permissions[page])
        } else {
          permission = (action ? this.state.login.logged_user.permissions[root][page]['actions'][action] : this.state.login.logged_user.permissions[root][page])
        }
      } else {
        permission = (action ? this.state.login.logged_user.permissions[root]['actions'][action] : this.state.login.logged_user.permissions[root])
      }
      return ((typeof permission !== 'undefined' && permission) || (root === 'test' && this.state.app.dev_mode))
    }
  }
}

export default router
